import type { MissionDetail, MissionSummary } from "@/services/api/agentic-v2";

/** User-facing mission title (entity + template), matching Mission Control windows. */
export function missionDisplayLabel(
  mission: MissionSummary | MissionDetail
): string {
  const entity = mission.entities[0]?.display_name || "Mission";
  const tmpl = mission.template_name || "";
  return tmpl ? `${entity} — ${tmpl}` : entity;
}
